export default "__VITE_ASSET__D_WPBvt1__"